<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>
        Change password
      </v-toolbar-title>
    </v-toolbar>
    <v-progress-linear
      class="mt-0"
      :active="progress"
      indeterminate
      color="yellow darken-2"
    ></v-progress-linear>
    <v-card-text>
      <span>Minimun length 8 charactes</span>
      <br>
      <span>Must contain at least one lower case letter</span>
      <br>
      <span>Must contain at least one upper case letter</span>
      <br>
      <span>Must contain at least one digit</span>
      <br>
      <span>Must contain at least one special character:
         ^ $ * . [ ] { } ( ) ? - " ! @ # % &amp; / \\ , &gt; &lt; ' : ; | _ ~</span>
      <br>
      <v-form ref="form" v-model="valid">
        <v-text-field
          :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
          :type="show ? 'text' : 'password'"
          :rules="passwordRules"
          name="input-10-2"
          label="New password"
          v-model="password"
          autocomplete="off"
          class="input-group--focused"
          @click:append="show = !show"
        ></v-text-field>
        <v-text-field
          type="password"
          name="input-10-2"
          label="Confirm password"
          v-model="verifyPassword"
          :rules="verifyPasswordRules"
          autocomplete="off"
          class="input-group--focused"
        ></v-text-field>
        <v-layout row class="bottom">
          <span
            class="return-to-signin"
            @click="back"
          >
            &larr; Back to sign in page
          </span>
          <v-btn
            color="blue"
            :disabled="!valid"
            light
            @click="newPassword"
          >
            Change password
          </v-btn>
        </v-layout>
      </v-form>
      <div class="auth-error" v-if="error">
        {{ error }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
/* eslint no-param-reassign: 0 */
/* eslint no-else-return: 0 */
import { Auth, Logger } from 'aws-amplify';
import EventBus from '@/utils/EventBus';

const logger = new Logger('NewPassword');

export default {
  name: 'NewPasswordView',
  props: {
    mail: {
      type: String,
      required: false,
    },
    click: {
      type: Function,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      progress: false,
      error: '',
      show: false,
      valid: true,
      password: '',
      passwordRules: [
        (v) => !!v || 'Password is required',
        (v) => (v && v.length >= 8) || 'Minimun length 8 charactes',
        (v) => (v && /.*[a-z]/.test(v)) || 'Must contain at least one lower case letter',
        (v) => (v && /.*[A-Z]/.test(v)) || 'Must contain at least one upper case letter',
        (v) => (v && /.*[0-9]/.test(v)) || 'Must contain at least one digit',
        (v) => (v && /.*[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`]/.test(v)) || 'Must contain at least one special character: ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' : ; | _ ~',
      ],
      verifyPassword: '',
      verifyPasswordRules: [
        (v) => (v && v === this.password) || '',
      ],
    };
  },
  computed: {
  },
  components: {
  },
  methods: {
    newPassword() {
      // Start progress indicator
      this.progress = true;

      Auth.completeNewPassword(this.user, this.password)
        .then((user) => {
          this.checkContact(user);
        })
        .catch((err) => {
          this.setError(err);
        })
        .finally(() => {
          this.progress = false;
        });
    },
    back() {
      EventBus.$emit('authState', 'LOG_IN');
    },
    checkContact(user) {
      Auth.verifiedContact(user)
        .then((data) => {
          if (!this.isEmpty(data.verified)) {
            return EventBus.$emit('authState', 'SIGNED_IN');
          } else {
            user = Object.assign(user, data);
            return null;
          }
        })
        .catch((err) => {
          this.setError(err);
        });
    },
    setError(e) {
      this.error = e.message || e;
      logger.error(this.error);
    },
    isEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
  },
};
</script>

<style scoped>
.auth-error {
  margin: 5px;
  padding: 3px;
  color: #E91300;
}
.bottom {
  justify-content: space-between;
  align-items: center;
}
.return-to-signin:hover {
  text-decoration: underline;
  cursor: pointer;
  color: #e66465;
}
</style>
